import(/* webpackMode: "eager", webpackExports: ["ProductShell"] */ "/vercel/path0/apps/web/components/product/ProductShell.tsx");
